import { TimePeriod } from 'graphql/data/util'
import { atom, useAtom } from 'jotai'
import { atomWithReset } from 'jotai/utils'
import { useCallback } from 'react'

export enum TokenSortMethodCompetition {
  TRADES_COUNT = 'Trades Count',
  Volume = 'Volume',
  Score = 'Score',
  Score24 = 'Score (24h)',
  SYMBOL = 'Symbol',
  NAME = 'Token Name',
}

export const SortableCategories: { [key in TokenSortMethodCompetition]: boolean } = {
  [TokenSortMethodCompetition.Score]: true,
  [TokenSortMethodCompetition.TRADES_COUNT]: true,
  [TokenSortMethodCompetition.Volume]: false,
  [TokenSortMethodCompetition.Score24]: true,
  [TokenSortMethodCompetition.SYMBOL]: false,
  [TokenSortMethodCompetition.NAME]: false,
}

const filterStringAtom = atomWithReset<string>('')
const filterTimeAtom = atom<TimePeriod>(TimePeriod.DAY)
export const sortMethodAtom = atom<TokenSortMethodCompetition>(TokenSortMethodCompetition.Score24)
export const sortAscendingAtom = atom<boolean>(false)

/* keep track of sort category for token table */
export function useSetSortMethod(newSortMethod: TokenSortMethodCompetition) {
  const [sortMethod, setSortMethod] = useAtom(sortMethodAtom)
  const [sortAscending, setSortAscending] = useAtom(sortAscendingAtom)

  return useCallback(() => {
    if (sortMethod === newSortMethod) {
      setSortAscending(!sortAscending)
    } else {
      setSortMethod(newSortMethod)
      setSortAscending(false)
    }
  }, [sortMethod, setSortMethod, setSortAscending, sortAscending, newSortMethod])
}
